import React from 'react';
import {
    Form, Row, Col, Select, Button, Modal,Icon
} from 'antd';
import img from './../../assets/img/Illustration.png';

const { Option } = Select;
const { confirm } = Modal;
class FD extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            carrier: this.props.quote && this.props.quote.quoteIteamDtos ? this.props.quote.quoteIteamDtos.filter(x => x.isCarrierFinalize) : []
        }
    }

    handleSubmit = (e) => {

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {

                this.props.submitHandler(values);

            }
        });
    }
    showConfirm = (record) => {
        confirm({
            title: 'Do you want to finalize this?',
            onOk: () =>
                this.handleSubmit(record),
            okText: "yes",
            cancelText: "No",
            onCancel: () =>
                this.props.closeDrawerHandler(record),
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="mi_model_popup">
                <Row span={24}>
                    <Col span={18}>
                        <p className='mi_title'>{this.props.title}</p>
                    </Col>

                </Row>
                <Form layout="vertical" hideRequiredMark>

                    <Row span={24}>
                        <Col sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Carrier</legend>
                                    {getFieldDecorator('carrier', {
                                        rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select Carrier. </span> }],
                                    })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                                        optionFilterProp="children"
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        placeholder="Please Select Carrier *">
                                        {this.state.carrier ? this.state.carrier.map(tag => <Option value={tag.carrier_Id} key={tag.carrier_Id}>{tag.carrier_Name}</Option>) : ""}
                                    </Select>)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row span={24} style={{ marginTop: '20px' }}>
                        <Col span={5}></Col>
                        <Col span={14}>
                            <Button className="submit-button" onClick={this.props.closeDrawerHandler} >
                                Cancel
                            </Button>

                            <Button className="submit-button" htmlType="submit" onClick={this.showConfirm} type="primary" >
                                Finalize
                            </Button>
                        </Col>
                        <Col span={7}>
                            <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const FinalizedQuote = Form.create()(FD);
export default FinalizedQuote;